"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var analytics_1 = require("@dynamynd/analytics");

var core_1 = require("@dynamynd/core");

var redux_observable_1 = require("redux-observable");

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

exports.userIsActiveEpic = function (actions$) {
  return actions$.pipe(redux_observable_1.ofType(core_1.ActionTypes.USER_IS_ACTIVE), operators_1.mergeMap(userIsActiveEpicHandler), operators_1.catchError(core_1.defaultErrorHandler));
}; //////////


var userIsActiveEpicHandler = function userIsActiveEpicHandler() {
  var isOnPageWithAnalytics = core_1.locationWebService.isOnPageWithAnalytics();

  if (isOnPageWithAnalytics) {
    return rxjs_1.of(analytics_1.resumeAllLastActiveAnalyticsSessionsActionCreator());
  }

  return rxjs_1.empty();
};